import { Point } from "pixi.js";
import { FeaturePurpleFishLandscapeProperties } from "../../../landscape/features/purplefish/FeaturePurpleFishLandscapeProperties";
export class FeaturePurpleFishPortraitProperties extends FeaturePurpleFishLandscapeProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.boxLeft.scale.set(1, 1);
        this.boxMiddle.scale.set(1, 1);
        this.boxRight.scale.set(1, 1);
        this.background.scale.set(1.2, 1.2);
        this.background.position.set(-614, -254);
        this.cat.scale.set(1.2, 1.2);
        this.cat.position.set(512, 900);
        this.boxLeft.position.set(512, 973);
        this.boxMiddle.position.set(512, 973);
        this.boxRight.position.set(512, 973);
        this.logoProperties.anchor.set(0.5, 0.5);
        this.logoProperties.position.set(430, 130);
        this.logoProperties.scale.set(0.8);
        this.logoProperties.visible = true;
        this.bowl.position = new Point(512, 971);
        this.bowl.scale.set(1);
        this.bubbleParticlesLeft.position = new Point(0, 973);
        this.bubbleParticlesRight.position = new Point(1024, 973);
        this.idleFishRangeX = [-620, +620];
        this.idleFishRangeY = [-950, -500];
        this.titleText.position = new Point(512, 450);
        this.helpText.position = new Point(512, 1000);
        this.titleText.scale.set(1);
        this.helpText.scale.set(1);
    }
}
